const etapes = [
  {
    num: "1",
    icon: "ri-phone-line",
    title: "Vous appelez et décrivez la panne",
    desc: "Contactez-nous au 03 74 47 32 40. Décrivez le symptôme : bloqué, ne remonte plus, moteur silencieux… Nous vous donnons un créneau d'intervention rapide, souvent le jour même.",
  },
  {
    num: "2",
    icon: "ri-search-line",
    title: "Diagnostic gratuit sur place",
    desc: "Notre technicien arrive à l'heure convenue, identifie la cause exacte de la panne et vous expose la solution adaptée. Le diagnostic est gratuit et sans engagement.",
  },
  {
    num: "3",
    icon: "ri-tools-line",
    title: "Réparation immédiate quand c'est possible",
    desc: "Dans la majorité des cas, nous réparons sur place. Les pièces courantes sont en stock. Si une pièce spécifique est nécessaire, nous revenons dans les 24h.",
  },
];

export default function Intervention() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Comment se passe l'<strong className="text-brand-blue">intervention</strong>
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Simple, rapide et transparent. Trois étapes pour remettre votre volet en service.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {etapes.map((etape) => (
            <div key={etape.num} className="text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-brand-cyan text-white text-xl font-bold mb-5">
                {etape.num}
              </div>
              <div className="w-10 h-10 mx-auto flex items-center justify-center mb-4">
                <i className={`${etape.icon} text-brand-blue text-2xl`}></i>
              </div>
              <h3 className="text-brand-blue text-lg font-bold mb-3">{etape.title}</h3>
              <p className="text-brand-text text-sm leading-relaxed max-w-sm mx-auto">{etape.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}